import React from "react";
import "./CustomSelect.css";

function CustomInput({
  label,
  name,
  type = "text",
  value,
  placeholder,
  error,
  helperText,
  onChange,
  required,
}) {
  const hasError = Boolean(error);

  return (
    <div className="custom-input-wrapper">
      {label && (
        <label
          htmlFor={name}
          className="custom-input-label"
          onClick={() => document.getElementById(name)?.focus()}
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <input
        id={name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={`custom-input-field ${hasError ? "custom-input-error" : ""}`}
      />

      {hasError && <p className="custom-input-helper custom-input-helper-error">{error}</p>}
    </div>
  );
}

export default CustomInput;
